import { useContext } from 'react';

import TableContext from '#/modules/commonComponents/table/TableContext';

export function useTableContext() {
  const context = useContext(TableContext);

  if (!context) {
    throw new Error('useTableContext must be used within a TableProvider');
  }

  return context.proxy;
}

export default useTableContext;
